export {default} from './CreditsAndRewards.connect';
